import GuestLoginMenu from "../GuestLoginMenu";
import MobileNavLinks from "./LoggedInMobileDrawerContent/MobileNavLinks";

export default function GuestMobileDrawerContent({
  onClose,
}: GuestMobileDrawerContentProps) {
  return (
    <>
      <div className="flex flex-col gap-2">
        <MobileNavLinks onClose={onClose} />
      </div>

      <GuestLoginMenu variant="mobile" onClose={onClose} />
    </>
  );
}

interface GuestMobileDrawerContentProps {
  onClose: () => void;
}
